import { Component, Input } from "@angular/core";

import { PhmsAuditActivityLogComponent } from "../../../phms/audit-activity/phms-audit-activity-log.component";
import { CaseContextActivityTimelinePanelComponent } from "../case-context-activity-timeline-panel/case-context-activity-timeline-panel.component";

@Component({
  selector: "phms-case-context-activity-tab",
  standalone: true,
  imports: [CaseContextActivityTimelinePanelComponent, PhmsAuditActivityLogComponent],
  template: `
    <section class="case-context-tab case-context-tab--activity" aria-label="Activity">
      <phms-case-context-activity-timeline-panel
        class="case-context-tab__panel"
        [incarceratedPersonId]="incarceratedPersonId"
      ></phms-case-context-activity-timeline-panel>

      <phms-audit-activity-log
        class="case-context-tab__panel"
        perspectiveCode="inmate"
        [subjectId]="incarceratedPersonId"
        title="Audit Activity"
      ></phms-audit-activity-log>
    </section>
  `,
  styleUrl: "./case-context-tab-layout.scss",
})
export class CaseContextActivityTabComponent {
  @Input({ required: true }) incarceratedPersonId!: number;
}
